import { Skeleton } from '@/components/ui'

export const DetalhesLoteSkeleton = () => {
  return (
    <section className="mt-4 flex flex-col gap-1">
      {/* Header skeleton */}
      <header className="flex flex-col gap-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-6 w-20" />
      </header>

      {/* Details skeleton */}
      <div className="mt-9 mb-10 text-sm">
        <span className="flex gap-4 border-b-1 py-2">
          <Skeleton className="h-4 w-22" />
          <Skeleton className="h-4 w-12" />
        </span>
        <span className="flex gap-4 border-b-1 py-2">
          <Skeleton className="h-4 w-22" />
          <Skeleton className="h-4 w-16" />
        </span>
        <span className="flex gap-4 border-b-1 py-2">
          <Skeleton className="h-4 w-22" />
          <Skeleton className="h-4 w-24" />
        </span>
      </div>

      {/* Buttons skeleton */}
      <div className="flex gap-6">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    </section>
  )
}
